export default {
      id: "phone-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }